module.exports = __webpack_public_path__ + "img/36-Dull.c87a153a.png";